import { MaytechService } from '../../_maytech/maytech.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpUtilsService } from '../../../core/_base/crud';
import { MaytechTenantService } from '../../_maytech/maytech.tenant.service';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../_reducers';
import { MessageLogModel } from '..';
import { Observable } from 'rxjs';
import { SendEmailModel } from '../../order-to-cash';

// Real REST API
@Injectable()
export class MessageLogService extends MaytechService {
    constructor(http: HttpClient,
        httpUtils: HttpUtilsService,
        route: ActivatedRoute,
        public store: Store<AppState>,
        tenantService: MaytechTenantService) {

        super(http, httpUtils, route, store, tenantService);

        if (tenantService.currentClient != null)
            this.API_URL = tenantService.currentClient.apiurl + '/messagelog';
    }
    // UPDATE => PUT: update the object on the server
    resendMessage(messageLogId: number): Observable<MessageLogModel> {
        const url = `${this.API_URL}/ResendMessage/${messageLogId}`;
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<MessageLogModel>(url, { headers: httpHeaders });
    }
    

    sendBookingEmail(obj: SendEmailModel): Observable<any> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = this.API_URL + `/SendBookingEmail`;
        return this.http.post<any>(url, obj, { headers: httpHeaders });
    }
}
